import Category from "../../entities/category";

/**
 * Category actions
 *
 * Call order:
 *
 * CATEGORY_SAVE_QUEUE:	adds the item to the save queue
 * --> CATEGORY_SAVE:	modifies the state
 * --> CATEGORY_SAVE_SUCCESS: if all went well
 * --> CATEGORY_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail CATEGORY_SAVE_QUEUE is during the call to CATEGORY_SAVE,
 * as adding an item to the queue should never fail.
 */

export const CATEGORY_FETCH_ONE_QUEUE: any = 'CATEGORY_FETCH_ONE_QUEUE';
export const CATEGORY_FETCH_SUCCESS: any = 'CATEGORY_FETCH_SUCCESS';
export const CATEGORY_FETCH_FAILURE: any = 'CATEGORY_FETCH_FAILURE';
export const CATEGORY_FETCH_ONE_SUCCESS: any = 'CATEGORY_FETCH_ONE_SUCCESS';
export const CATEGORY_FETCH_ONE_FAILURE: any = 'CATEGORY_FETCH_ONE_FAILURE';

export const CATEGORY_SAVE: any = 'CATEGORY_SAVE';
export const CATEGORY_SAVE_QUEUE: any = 'CATEGORY_SAVE_QUEUE';
export const CATEGORY_SAVE_SUCCESS: any = 'CATEGORY_SAVE_SUCCESS';
export const CATEGORY_SAVE_FAILURE: any = 'CATEGORY_SAVE_FAILURE';

export const CATEGORY_SAVE_MANY: any = 'CATEGORY_SAVE_MANY';
export const CATEGORY_SAVE_MANY_QUEUE: any = 'CATEGORY_SAVE_MANY_QUEUE';
export const CATEGORY_SAVE_MANY_SUCCESS: any = 'CATEGORY_SAVE_MANY_SUCCESS';
export const CATEGORY_SAVE_MANY_FAILURE: any = 'CATEGORY_SAVE_MANY_FAILURE';

export const CATEGORY_REMOVE: any = 'CATEGORY_REMOVE';
export const CATEGORY_REMOVE_QUEUE: any = 'CATEGORY_REMOVE_QUEUE';
export const CATEGORY_REMOVE_SUCCESS: any = 'CATEGORY_REMOVE_SUCCESS';
export const CATEGORY_REMOVE_FAILURE: any = 'CATEGORY_REMOVE_FAILURE';

export const CATEGORY_RESTORE: any = 'CATEGORY_RESTORE';
export const CATEGORY_RESTORE_QUEUE: any = 'CATEGORY_RESTORE_QUEUE';
export const CATEGORY_RESTORE_SUCCESS: any = 'CATEGORY_RESTORE_SUCCESS';
export const CATEGORY_RESTORE_FAILURE: any = 'CATEGORY_RESTORE_FAILURE';

export const CATEGORY_RESTORE_MANY: any = 'CATEGORY_RESTORE_MANY';
export const CATEGORY_REMOVE_MANY: any = 'CATEGORY_REMOVE_MANY';

/* Fetch actions */
export const fetchCategorySuccess = (categories: Category[], partial: boolean, lastFetch: number) => ({type: CATEGORY_FETCH_SUCCESS, categories, partial, lastFetch});
export const fetchCategoryFailure = (err: any) => {
		console.error('CategoryAction: fetchCategoryFailure', err);
		return {type: CATEGORY_FETCH_FAILURE, err};
};
export const fetchOneCategoryQueue = (categoryId: string) => ({type: CATEGORY_FETCH_ONE_QUEUE, categoryId});
export const fetchOneCategorySuccess = (category: Category) => ({type: CATEGORY_FETCH_ONE_SUCCESS, category});
export const fetchOneCategoryFailure = (id: string, err: any) => {
		console.error('CategoryAction: fetchOneCategoryFailure', err);
		return {type: CATEGORY_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveCategory = (category: Category) => {
    // console.debug('⮂ CATEGORY_SAVE action', category?.id);
    return {type: CATEGORY_SAVE, category};
}
export const saveCategoryQueue = (category: Category) => {
    // console.debug('⮂ CATEGORY_SAVE_QUEUE action', category?.id);
    return {type: CATEGORY_SAVE_QUEUE, category};
}
export const saveCategorySuccess = (category: Category) => {
    // console.debug('⮂ CATEGORY_SAVE_SUCCESS action', category?.id);
    return {type: CATEGORY_SAVE_SUCCESS, category};
}
export const saveCategoryFailure = (category: Category, status: number, message: string) => {
    console.warn(`⮂ CATEGORY_SAVE_FAILURE error saving category: HTTP ${status}: ${message}`, category?.id);
    return {type: CATEGORY_SAVE_FAILURE, category, status, message};
};

/* SaveMany actions */
export const saveManyCategories = (categories: Category[]) => {
    // console.debug('⮂ CATEGORY_SAVE_MANY action', categories?.map(category => category?.id).join(','));
    return {type: CATEGORY_SAVE_MANY, categories};
}
export const saveManyCategoriesQueue = (categories: Category[]) => {
    // console.debug('⮂ CATEGORY_SAVE_MANY_QUEUE action', categories?.map(category => category.id).join(','));
    return {type: CATEGORY_SAVE_MANY_QUEUE, categories};
}

export const saveManyCategoriesSuccess = (categories: Category[]) => {
    // console.debug('⮂ CATEGORY_SAVE_MANY_SUCCESS action', categories?.map(category => category.id).join(','));
    return {type: CATEGORY_SAVE_MANY_SUCCESS, categories};
}
export const saveManyCategoriesFailure = (categories: Category[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_CATEGORIES_FAILURE Error saving categories: HTTP ${status}: ${message}`, categories?.map(category => category.id).join(','));
		return {type: CATEGORY_SAVE_MANY_FAILURE, categories, status, message};
};

/* Remove actions */
export const removeCategory = (category: Category) => ({ type: CATEGORY_REMOVE, category });
export const removeCategoryQueue = (category: Category) => ({ type: CATEGORY_REMOVE_QUEUE, category });
export const removeCategorySuccess = (category: Category) => ({ type: CATEGORY_REMOVE_SUCCESS, category });
export const removeCategoryFailure = (category: Category, status: number, message: string) => {
	console.error(`Redux: removeCategoryFailure Error removing category: HTTP ${status}: ${message}`);
	return ({ type: CATEGORY_REMOVE_FAILURE, category, status, message });
};

/* Restore actions */
export const restoreCategory = (category: Category) => ({ type: CATEGORY_RESTORE, category });
export const restoreCategoryQueue = (category: Category) => ({ type: CATEGORY_RESTORE_QUEUE, category });
export const restoreCategorySuccess = (category: Category) => ({ type: CATEGORY_RESTORE_SUCCESS, category });
export const restoreCategoryFailure = (category: Category, status: number, message: string) => {
	console.error(`Redux: restoreCategoryFailure Error restoring category: HTTP ${status}: ${message}`);
	return ({ type: CATEGORY_RESTORE_FAILURE, category, status, message });
};

/* RestoreMany actions */
export const restoreManyCategories = (categories: Category[]) => ({ type: CATEGORY_RESTORE_MANY, categories });

/* RemoveMany actions */
export const removeManyCategories = (categories: Category[]) => ({ type: CATEGORY_REMOVE_MANY, categories });